import { Injectable } from '@angular/core';
import { ProcessDesignerUIState } from './process-designer.uistate';
import { ElementPropertyConfig, PropertyEntity } from '@farris/ide-property-panel';
import { VoConfigComponent, VoConfigConverter } from '../views/vo-config/vo-config.component';
import { WfOptionsComponent, WfOptionsConverter } from '../views/wf-options/wf-options.component';
import { WfLocalePipe } from '../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()
export class BillNodeActivityAdapter {
    constructor(
        private uiState: ProcessDesignerUIState,
        private localPipe: WfLocalePipe
    ) {
    }
    setProperty(obj: any) {
        this.uiState.propertyData = obj.propertyData;
        this.uiState.propertyConfig = this.setConfig(obj.propertyConfig);
    }

    private setConfig(obj: any[]): ElementPropertyConfig[] {
        const propertyConfig: ElementPropertyConfig[] = [];
        if (obj) {
            obj.forEach((element: ElementPropertyConfig) => {
                this.setEntity(element.properties);
                propertyConfig.push(element);
            });
        }
        return propertyConfig;
    }
    private setEntity(obj: PropertyEntity[]) {
        if (obj && obj.length > 0) {
            obj.forEach((item: PropertyEntity) => {
                switch (item.propertyID) {
                    case "VoConfig":
                        item.converter = new VoConfigConverter(this.localPipe);
                        item.editor = VoConfigComponent;
                        item.editorParams = {
                            bizTypeId: this.uiState.flowFormInfo.flowForm.businessObjectId
                        };
                        break;
                    case "WfOpts":
                        item.converter = new WfOptionsConverter(this.localPipe);
                        item.editor = WfOptionsComponent;
                        item.editorParams = {
                            bizTypeId: this.uiState.flowFormInfo.flowForm.businessObjectId
                        };
                        break;
                    case "wfConfig": //启用工作流
                        item.iterator = this.uiState.boolIterator;
                        break;
                    default:
                        break;
                }
            });
        }
    }
}
